/** @returns {boolean} */
export function isEmailRemEnabledForUser(userData) {
  return Boolean(
    userData?.permissions?.remindersEnabled && userData?.permissions?.emailRemEnabled
  );
}

/** Admin roles that can assign Email Reminder in user management and Home Designer. */
export const EMAIL_REM_ADMIN_ROLES = new Set(['superadmin', 'admin', 'tenant_admin']);
